/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Ask_User_Skipped_CountInputs */



/**
* | output |
* | --- |
* | "Skipped {count} questions" |
*
* @param {Chat_Ask_User_Skipped_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_ask_user_skipped_count = /** @type {((inputs: Chat_Ask_User_Skipped_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Ask_User_Skipped_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Fragen übersprungen`)
	return /** @type {LocalizedString} */ (`Skipped ${i?.count} questions`)
});